export default "__VITE_ASSET__fde99044__"